import { network } from 'services/network';

export const associateCardWithLogicChecker = (params) => {
    return network.post('api/bo/associateCardWithLogicChecker', params).then((response) => {
        return response.data;
    });
};
